module.exports = __webpack_public_path__ + "static/media/involuntary.a25c71c7.ogg";